import {Box as ChakraBox, BoxProps} from '@chakra-ui/react'

// Après pas mal de prises de tête avec ce composant j'ai remarqué que c'était un peu la div calle partout. On la customera au besoin dans le dur, mais j'utiliserai plutôt container quand il y aura des mises en page particulières
export const Box = (props: BoxProps) => {
  return <ChakraBox {...props}></ChakraBox>
}
export default Box
